
import { defineComponent } from 'vue';
import { useI18n } from '@/i18n-shim';

import LocalizedInfoSection from './localizedInfoSection.vue';
import Layout from './layout.vue';

export default defineComponent({
  components: {
    localizedInfoSection: LocalizedInfoSection,
    layout: Layout
  },
  props: {
    tenantId: {
      type: String,
      required: true
    }
  },
  setup() {
    return {
      ... useI18n(),
    }
  }
});
